import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M12 2.1a1 1 0 1 0 0-2 1 1 0 0 0 0 2M7.25 4.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2M3.5 6.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M3.5 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0M13 22.9a1 1 0 1 1-2 0 1 1 0 0 1 2 0M21.5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M22.5 17.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M16.75 21.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2M3.5 17.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7.25 21.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2M22.5 6.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M13.375 6.5a1.375 1.375 0 1 1-2.75 0 1.375 1.375 0 0 1 2.75 0M16.763 10.625a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75M18.138 14.75a1.375 1.375 0 1 1-2.75 0 1.375 1.375 0 0 1 2.75 0M12 18.875a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75M8.612 14.75a1.375 1.375 0 1 1-2.75 0 1.375 1.375 0 0 1 2.75 0M7.237 10.625a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75M13.75 12a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M16.75 4.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
  </>
);

const Aqi = Icon('aqi', svgContents);

export default Aqi;
